<template>
    <div class="app-options">
        <mu-row>
            <mu-col span="6" sm="6" md="6" lg="4" xl="3" v-for="(item, key) in menu" :key="key">
                <router-link :to="{ name: item.route }">
                    <img :src="item.icon" v-if="item.icon">
                    <h3>{{ item.title }}</h3>
                    <span class="description">{{ item.description }}</span>
                </router-link>
            </mu-col>
        </mu-row>
    </div>
</template>

<script>
    export default {
        name: 'options',
        props: ['options'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                menu: [],
                ignoreCustomTypeClient: [
                    'app.settings.clients',
                    // 'app.settings.users',
                    'app.settings.credits'
                ]
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted () {
            this.process()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Faz um filtro de acordo com o que o usuário/empresa pode
             * visualizar no menu
             */
            process () {
                this.menu = this.options.filter((item) => {
                    if (this.ignoreCustomTypeClient.includes(item.route) && this.$store.state.company.customType === 'C') {
                        return false
                    }
                    if (item.permition_company && !item.permition_company.includes(this.$store.state.company.customType)) {
                        return false
                    }
                    return item.permition.includes(this.$store.state.user.permition)
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .app-options

        text-align center
        padding-top 30px

        .col

            a
                color #999
                font-size 12px
                padding 15px 0
                display block
                max-width 300px
                margin auto
                transition all 0.4s
                border 1px #f5f5f5 solid

                img
                    width 50px
                    height 50px

                h3
                    font-weight 500
                    font-size 14px
                    margin 0
                    color #666

                .description
                    display none

                &:hover
                    background rgba(255, 255, 255, 0.3)
                    border-radius 6px
                    border 1px #ccc dotted
                    -webkit-box-shadow 0px 0px 50px 0px rgba(0,0,0,0.05)
                    -moz-box-shadow 0px 0px 50px 0px rgba(0,0,0,0.05)
                    box-shadow 0px 0px 50px 0px rgba(0,0,0,0.05)

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .app-options

            .col
                margin-top 20px
                margin-bottom 20px

                a
                    padding 20px 30px

                    img
                        width 70px
                        height 70px

                    .description
                        display block

</style>
